<script lang="ts" setup>import { computed as _computed } from 'vue';

import { ProgressStepItemProps, ProgressSteps, AppButton } from '@pohlcon/design-system';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { MessageSchema } from '~/locales';
import { useMainStore } from '~/store';

const { t } = useI18n<{ message: MessageSchema; }>()

const store = useMainStore();
const router = useRouter();

const activeStepId = computed({
  get: () => store.activeStepId,
  set: (value: string) => store.activeStepId = value
});

const links: ProgressStepItemProps[] = _computed(() =>
  store.steps.map((step) => ({
    text: t(`nav.${step.id}`),
    ...step
  }))
);

const routeToStep = (stepId: string) => {
  activeStepId.value = stepId;
  router.push(store.currentStep.to);
};
</script>

<template>
  <div id="nav">
    <ProgressSteps
      v-if="router.currentRoute.value.name !== 'Data'"
      :modelValue="activeStepId"
      :steps="links"
      @update:modelValue="(stepId: string) => routeToStep(stepId)"
    />
    <AppButton
      v-else
      text="Back to Home"
      :to="'/'"
    />
  </div>
</template>


<style lang="scss" scoped>

  #nav {
    margin-top: var(--gutter-2xl);
    margin-bottom: var(--gutter-3xl);

    :deep(.progress-steps) {
      display: flex;
      justify-content: center;

      .progress-steps__container {
        flex-grow: 0.1;
      }

      .progress-step__item {
        button.marker {
          color: unset;
          border: unset;
          background-color: unset;
        }
        &:not(.current) button.marker {
          cursor: pointer;
        }
      }
    }
  }
</style>
